export const speaking = {
    uk: {
        heading: "Говоріння",
        squares: [
            { title: "Діалоги", path: "/speaking/dialogues" },
            { title: "Розповіді", path: "/speaking/stories" }
        ],
        dialogsHeader: "Діалоги",
        storiesHeader: "Розповіді",
        listOfLessons: "Список уроків"
    },
    en: {
        heading: "Speaking",
        squares: [
            { title: "Dialogues", path: "/speaking/dialogues" },
            { title: "Stories", path: "/speaking/stories" }
        ],
        dialogsHeader: "Dialogues",
        storiesHeader: "Stories",
        listOfLessons: "List of Lessons"
    }
}